import { defineMessages } from 'react-intl';

export default defineMessages({
  description: { defaultMessage: 'How do you want to repay?' },

  withYourCurrentCollateral: { defaultMessage: 'With your current collateral' },
  fromYourWalletBalance: { defaultMessage: 'From your wallet balance' },
});
